import { CommunityTab, CommunityTabs, PostTypes } from '@outlaw/community';
import { CommunityFeature } from '../interfaces/community-feature';
import { ProjectConfig } from '../interfaces/project-config';
import { CustomTheme } from '@app/models';
import { FeatureState } from '@outlaw/core';
import { defaultNavigationItems } from '../constance/navigation-items';

export const CALENDAR_EVENTS_LIMIT = 6;
export const CALENDAR_EVENTS_ROUTE = '/widgets/calendar';

export const profileTabs: CommunityTab[] = [
  {
    id: CommunityTabs.RECS,
    title: 'Recs',
    fetchParams: {},
    emptyState: {
      icon: 'recommend',
      label: "User hasn't recommended anything yet",
    },
  },
  {
    id: CommunityTabs.DISCUSSIONS,
    title: 'Discussions',
    fetchParams: {},
    emptyState: {
      icon: 'comment',
      label: "User hasn't commented anything yet",
    },
  },
];

export const postsTab: CommunityTab[] = [
  {
    id: 'posts',
    title: 'Posts',
    fetchParams: {
      post_types: [PostTypes.post, PostTypes.socialPost, PostTypes.postedVideo],
    },
    emptyState: {
      icon: 'post',
      label: "User hasn't published anything yet",
    },
  },
];

export const userTabs: CommunityTab[] = [
  {
    id: CommunityTabs.POSTS,
    title: 'All Posts',
    fetchParams: {},
    emptyState: {
      icon: 'post',
      label: 'Posts not found',
    },
  },

  {
    id: CommunityTabs.DISCUSSIONS_ALL,
    title: 'Discussions',
    fetchParams: {},
    emptyState: {
      icon: 'comment',
      label: "User hasn't commented anything yet",
    },
  },
];

export const groupTabs: CommunityTab[] = [
  {
    id: CommunityTabs.GROUP,
    title: 'All Posts',
    fetchParams: {},
  },
  {
    id: CommunityTabs.DISCUSSIONS,
    title: 'Discussions',
    fetchParams: {},
  },
];

const featureFlags: Record<CommunityFeature, FeatureState> = {
  [CommunityFeature.profileBlock]: FeatureState.enabled,
  [CommunityFeature.commonFeed]: FeatureState.disabled,
  [CommunityFeature.imageBackground]: FeatureState.enabled,
  [CommunityFeature.sideNavigation]: FeatureState.enabled,
  [CommunityFeature.openProfileLinksInSameWindow]: FeatureState.enabled,
  [CommunityFeature.profileBackgroundGradient]: FeatureState.enabled,
};

export const projectConfig: ProjectConfig = {
  links: {
    instagram: '/',
    facebook: '/',
    twitter: '/',
    youtube: '/',
    spotify: '/',
  },
  features: featureFlags,
  defaultTheme: CustomTheme.dharmann,
  navigationItems: defaultNavigationItems,
  profileType: 'group',
};
